module.exports = __webpack_public_path__ + "static/media/Group.7f9e6155.png";